import * as parts from './parts'

export interface BannerColors {
  BannerButton: parts.BannerButtonColors
  NotificationBanner: parts.NotificationBannerColors
  VersionBanner: parts.VersionBannerColors
}

export const bannerColors: BannerColors = {
  BannerButton: parts.bannerButtonColors,
  NotificationBanner: parts.notificationBannerColors,
  VersionBanner: parts.versionBannerColors,
}
